import { createContext, useContext, useEffect, useState } from 'react'
import { io } from 'socket.io-client'

const SocketContext = createContext(null)

export const SocketProvider = ({ children, options = {} }) => {
  const [socket, setSocket] = useState(null)

  useEffect(() => {
    const socketInstance = io(process.env.REACT_APP_SERVER_URL, options)
    setSocket(socketInstance)

    return () => {
      socketInstance.disconnect()
    }
  }, [])

  return <SocketContext.Provider value={{ socket }}>{children}</SocketContext.Provider>
}

export const useSocketContext = () => {
  const context = useContext(SocketContext)
  if (!context || !context.socket) {
    throw new Error('useSocketContext must be used within a SocketProvider')
  }
  return context.socket
}

export const useSocket = (eventHandlers = {}) => {
  const { socket } = useContext(SocketContext)

  useEffect(() => {
    if (!socket) return

    Object.entries(eventHandlers).forEach(([event, handler]) => {
      socket.on(event, handler)
    })

    return () => {
      Object.entries(eventHandlers).forEach(([event, handler]) => {
        socket.off(event, handler)
      })
    }
  }, [socket, eventHandlers])
}
